import type { BuyListSavedViews } from '~/pages/buy-lists/lib/useBuyListSavedViews';
import { BuyListFilterControls } from './BuyListFilterControls';
import { BuyListTeamFilter, type BuyListTeamMember } from './BuyListTeamFilter';

type BuyListToolbarProps = {
  readonly buyers: BuyListTeamMember[];
  readonly isLoadingBuyers: boolean;
  readonly hasBuyersFailed: boolean;
  readonly isLoadingSavedTeam: boolean;
  readonly locations: { label: string; value: string }[];
  readonly transportVehicles: { label: string; value: string }[];
  readonly products: { label: string; value: string }[];
  readonly isLoadingProducts: boolean;
  readonly views: BuyListSavedViews;
  readonly teamMemberIds: string[];
  readonly teamActive: boolean;
  readonly onTeamActiveChange: (active: boolean) => void;
  readonly onSaveTeam: (teamMemberIds: string[]) => void;
};

export function BuyListToolbar({
  buyers,
  isLoadingBuyers,
  hasBuyersFailed,
  isLoadingSavedTeam,
  locations,
  transportVehicles,
  products,
  isLoadingProducts,
  views,
  teamMemberIds,
  teamActive,
  onTeamActiveChange,
  onSaveTeam,
}: BuyListToolbarProps) {
  return (
    <div
      className="flex items-center gap-3 flex-wrap justify-between p-2 px-4"
      data-testid="buy-list-toolbar"
    >
      <BuyListTeamFilter
        buyers={buyers}
        isLoadingBuyers={isLoadingBuyers}
        hasBuyersFailed={hasBuyersFailed}
        isLoadingSavedTeam={isLoadingSavedTeam}
        teamMemberIds={teamMemberIds}
        teamActive={teamActive}
        onTeamActiveChange={onTeamActiveChange}
        onSaveTeam={onSaveTeam}
      />

      <BuyListFilterControls
        locations={locations}
        transportVehicles={transportVehicles}
        products={products}
        isLoadingProducts={isLoadingProducts}
        views={views}
      />
    </div>
  );
}
